import React from 'react'
import { Modal } from '@surecompanies/core_components'
import { Button } from '@sureco/design-system'
import { CensusFileRowGridData } from '../types/census-file-row-grid-data'

interface SendForReviewConfirmationModalProps {
  visible: boolean
  onCancel: () => void
  onConfirm: () => void
  loading: boolean
  validRows: CensusFileRowGridData[]
  excludedRows: CensusFileRowGridData[]
}

const rowLabel = (row: CensusFileRowGridData) => {
  const name = `${row.firstName ?? ''} ${row.lastName ?? ''}`.trim()
  const id = row.CompanyEmployeeId ?? row.employeeId ?? ''
  return id ? `${id} — ${name}` : name || `Row #${row.id}`
}

const SendForReviewConfirmationModal = ({
  visible,
  onCancel,
  onConfirm,
  loading,
  validRows,
  excludedRows,
}: SendForReviewConfirmationModalProps) => {
  return (
    <Modal
      title="Confirm Send For Review"
      open={visible}
      onCancel={onCancel}
      width={520}
      footer={[
        <div
          key="footer"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Button
            type="outline"
            variant="secondary"
            onClick={onCancel}
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            loading={loading}
            variant="primary"
            size="large"
            disabled={validRows.length === 0}
          >
            Send For Review ({validRows.length})
          </Button>
        </div>,
      ]}
    >
      {validRows.length > 0 && (
        <>
          <p>
            <strong>{validRows.length}</strong>{' '}
            {validRows.length === 1 ? 'record' : 'records'} will be sent for
            review:
          </p>
          <div
            style={{
              paddingLeft: 4,
              marginBottom: 16,
              maxHeight: 200,
              overflowY: 'auto',
            }}
          >
            {validRows.map((row, index) => (
              <div key={row.id} style={{ marginBottom: 4 }}>
                <span style={{ marginRight: 8, color: '#999' }}>
                  {index + 1}.
                </span>
                <span>{rowLabel(row)}</span>
              </div>
            ))}
          </div>
        </>
      )}

      {excludedRows.length > 0 && (
        <>
          <p style={{ color: '#ad8b00' }}>
            <strong>{excludedRows.length}</strong>{' '}
            {excludedRows.length === 1 ? 'record' : 'records'} cannot be sent
            for review and will be excluded. This includes new employee records
            and records with duplicate SSN, Email Address, or Company Employee
            ID:
          </p>
          <div
            style={{
              paddingLeft: 4,
              marginBottom: 16,
              maxHeight: 200,
              overflowY: 'auto',
            }}
          >
            {excludedRows.map((row, index) => (
              <div key={row.id} style={{ marginBottom: 4, color: '#ad8b00' }}>
                <span style={{ marginRight: 8 }}>{index + 1}.</span>
                <span>{rowLabel(row)}</span>
              </div>
            ))}
          </div>
        </>
      )}

      {validRows.length === 0 && (
        <p style={{ color: '#ff4d4f' }}>
          All selected records are new employees and cannot be sent for review.
        </p>
      )}
    </Modal>
  )
}

export default SendForReviewConfirmationModal
